import styled from '@emotion/styled';
import Icon from '@mdi/react';
import { Variables } from '../../base';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Label = styled.div`
    font-family: ${Variables.Fonts.calibre};
    font-size: ${Variables.FontSizes.tiny};
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.TextMedium};
    letter-spacing: 0%;
    line-height: 100%;
`;

export const InnerCol = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;

    textarea {
        resize: vertical !important;
    }
`;
export const InputAttachments = styled.div`
    padding-top: 16px;
    margin-top: 8px;
    margin-bottom: 8px;
    border-top: 1px solid ${Variables.Colors.platinum};
`;
export const DragOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Variables.Colors.nx16};
    color: ${Variables.Colors.b400};
    font-size: 16px;
    pointer-events: none;
    border-radius: 8px;
`;

export const Latin1Error = styled.div`
    display: flex;
    align-items: center;
    color: ${Variables.Colors.warning};
    font-size: 13px;
    font-weight: 500;
    margin-top: 4px;
`;

export const Latin1ErrorIcon = styled(Icon)`
    fill: ${Variables.Colors.warning};
    margin-right: 4px;
`;
